import { useState } from "react";
import api from "../../../utils/axios";
import PagePreview from "./PagePreview";

function slugify(value) {
    return value
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
}


function PageCreateForm({ onCreated }) {
    const [showPreview, setShowPreview] = useState(false);

    const [form, setForm] = useState({
        title: "",
        slug: "",
        route_path: "",
        description: "",
        page_type: "standard",
        is_published: true
    });

    const [previewSections, setPreviewSections] = useState([
        {
            temp_id: "hero-preview",
            section_type: "hero",
            section_name: "Preview Hero",
            zone: "main",
            sort_order: 1,
            is_visible: true,
            settings_json: {
                title: "New Page Title",
                subtitle: "Preview subtitle",
                alignment: "center",
                variant: "large",
                button_text: "",
                button_url: ""
            },
            items: []
        }
        ]);

    const updateField = (field, value) => {
        setForm((prev) => {
            const next = { ...prev, [field]: value };

            if (field === "title") {
                const slug = slugify(value);
                next.slug = slug;
                next.route_path = slug ? `/${slug}` : "";

                setPreviewSections((sections) =>
                    sections.map((section) =>
                        section.section_type === "hero"
                            ? {
                        ...section,
                                settings_json: {
                            ...section.settings_json,
                                    title: value || "New Page Title"
                        }
                    }
                    : section
                    )
                );
            }

            if (field === "route_path" && value && !value.startsWith("/")) {
                next.route_path = `/${value}`;
            }

            return next;
        });
    };

    const submit = async (e) => {
        e.preventDefault();

        await api.post("/pages", form);

        onCreated();

        setForm({
            title: "",
            slug: "",
            route_path: "",
            description: "",
            page_type: "standard",
            is_published: true
        });
    };

    const previewPage = {
        id: "preview",
        title: form.title,
        slug: form.slug,
        route_path: form.route_path,
        description: form.description,
        page_type: form.page_type,
        is_published: form.is_published
    };


    return (
        <div className="admin-form-wrapper">
            <form onSubmit={submit} className="admin-form">
                <h3>Create New Page</h3>

                <label>Page title
                    <input
                        name={"title"}
                        value={form.title}
                        onChange={(e) => updateField("title", e.target.value)}
                        placeholder="About Us"
                        required
                    />
                </label>

                <label>Slug
                    <input
                        name={"slug"}
                        value={form.slug}
                        onChange={(e) => updateField("slug", e.target.value)}
                        placeholder="about-us"
                        required
                    />
                </label>

                <label>Relative path
                    <input
                        name={"route_path"}
                        value={form.route_path}
                        onChange={(e) => updateField("route_path", e.target.value)}
                        placeholder="/about-us"
                        required
                    />
                </label>

                <label>Page type
                    <select
                        name="page_type"
                        value={form.page_type}
                        onChange={(e) => updateField("page_type", e.target.value)}
                    >
                        <option value="standard">Standard</option>
                        <option value="home">Home</option>
                        <option value="landing">Landing</option>
                        <option value="content">Content</option>
                    </select>
                </label>

                <label>Description
                    <textarea
                        name="description"
                        value={form.description}
                        onChange={(e) => updateField("description", e.target.value)}
                    />
                </label>

                <label>
                    <input
                        name={"check"}
                        type="checkbox"
                        checked={form.is_published}
                        onChange={(e) => updateField("is_published", e.target.checked)}
                    />
                    Published
                </label>

                <button className={"button"} type="button" onClick={() => setShowPreview((prev) => !prev)}>
                    {showPreview ? "Hide Preview" : "Preview New Page"}
                </button>

                <button className={"button"} type="submit">Create Page</button>
            </form>

            {showPreview && (
                <PagePreview
                    page={previewPage}
                    sections={previewSections}
                />
            )}
        </div>
    );
}

export default PageCreateForm;